export enum ELoading {
  LOADING = 'loading',
  FINISHED = 'finished',
  ERROR = 'error',
  IDLE = 'idle',
  APPROVING_TOKENS = 'Approving tokens for deposit.',
  GENERATING_PROOF = 'Converting the proof.',
  TRANSACTION_SENT = 'Transaction sent.',
  TRANSACTION_MINED = 'Transaction mined.',
  RELAYER_ERROR = 'Relayer error.'
}

export type ELoadingType = `${ELoading}`;
